import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { CanvasService } from '../canvas.service'
import { CanvasArgs, CanvasCommand } from '../commands/canvas-command.model'
import { ClearTraceCommand } from '../commands/clear-trace.command'
import { ExitTraceModeCommand } from '../commands/exit-trace-mode.command'
import { RunCanvasCommand } from '../commands/run-canvas.command'
import { DdcCommandInvokerComponent } from '../ddc-command-invoker/ddc-command-invoker.component'

@Component({
  selector: 'ddc-canvas-management-toolbar',
  templateUrl: './ddc-canvas-management-toolbar.component.html',
  styleUrls: ['./ddc-canvas-management-toolbar.component.scss'],
  imports: [CommonModule, AngularMaterialsModules, DdcCommandInvokerComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class DdcCanvasManagementToolbarComponent {
  @Input() canvasId: number | null = null
  @Input() isRunning = false
  @Input() canRun = false
  @Input() isTraceMode = false

  @Output() runCanvas = new EventEmitter<void>()
  @Output() clearTrace = new EventEmitter<void>()
  @Output() exitTrace = new EventEmitter<void>()

  readonly runCommand: RunCanvasCommand
  readonly clearTraceCommand: ClearTraceCommand
  readonly exitTraceModeCommand: ExitTraceModeCommand
  readonly commands: CanvasCommand[]

  constructor(canvasService: CanvasService) {
    this.runCommand = new RunCanvasCommand(canvasService)
    this.clearTraceCommand = new ClearTraceCommand(canvasService)
    this.exitTraceModeCommand = new ExitTraceModeCommand(canvasService)
    this.commands = [this.runCommand, this.clearTraceCommand]
  }

  argsFor(command: CanvasCommand): CanvasArgs {
    const base: CanvasArgs = {
      canvasId: this.canvasId,
      canvasTitle: '',
      hasUnsavedChanges: !this.canRun,
      isSaving: false,
      isRunning: this.isRunning,
      isTraceMode: this.isTraceMode,
    }

    switch (command.id) {
      case 'run-canvas':
        return { ...base, action: () => this.runCanvas.emit() }
      case 'clear-trace':
        return { ...base, action: () => this.clearTrace.emit() }
      case 'exit-trace-mode':
        return { ...base, action: () => this.exitTrace.emit() }
      default:
        return base
    }
  }

  onCommandExecuted(): void {
    // Client-side delegates handle the work; nothing to forward here.
  }
}
